export const cutStringHandler = (
  string?: string,
  charsLimit: number = 177
): string => {
  if (string) {
    return string.length > charsLimit
      ? string.slice(0, charsLimit) + "..."
      : string;
  }
  return "";
};
